import { makeStyles } from '@material-ui/core/styles';
import { Alert, AlertTitle } from '@material-ui/lab';
import React, { useState } from 'react';

const useStyles = makeStyles(theme => ({
  root: {
    width: '90%',
    margin: 'auto',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
  alertTitle: {
    color: 'white',
  },
}));

function CustomAlert({
  errorMessage,
  severity,
  alertTitle,
  onClose,
  alertAction,
  showAlert = false,
  className,
}) {
  const classes = useStyles();
  const [close, setClose] = useState(false);

  const handleAlertClose = event => {
    setClose(true);
    if (onClose) {
      onClose(event);
    }
  };

  return (
    <>
      {showAlert === true && !close && (
        // eslint-disable-next-line react/jsx-no-duplicate-props
        <div className={classes.root} className={className}>
          <Alert
            variant="filled"
            severity={severity}
            onClose={handleAlertClose}
            action={alertAction}
          >
            {alertTitle && <AlertTitle className={classes.alertTitle}>{alertTitle}</AlertTitle>}
            {errorMessage}
          </Alert>
        </div>
      )}
    </>
  );
}

export { CustomAlert, Alert };
